import React, { useState } from "react";

const ShieldMark = () => (
  <span className="logo-mark" aria-hidden="true">
    <svg viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2 L36 8 V22 C36 33 29 40 20 42.5 C11 40 4 33 4 22 V8 Z" fill="#C39A54" />
      <path d="M20 9 L22.6 18.4 L31 21 L22.6 23.6 L20 33 L17.4 23.6 L9 21 L17.4 18.4 Z" fill="#142744" />
    </svg>
  </span>
);

const links = [
  { href: "#why", label: "Why Northstar" },
  { href: "#approach", label: "Our Approach" },
  { href: "#process", label: "Selling to Us" },
  { href: "#faq", label: "FAQ" },
];

const SentinelNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav aria-label="Main">
      <div className="wrap navbar">
        <a className="logo" href="#top" aria-label="Northstar Service Partners home">
          <ShieldMark />
          <span className="logo-word">NORTHSTAR<span>{"\u00A0SERVICE PARTNERS"}</span></span>
        </a>
        <button
          className="menu-btn"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span></span><span></span><span></span>
        </button>
        <ul className={`navlinks ${open ? "open" : ""}`} id="navlinks">
          {links.map((l) => (
            <li key={l.href}>
              <a href={l.href} onClick={() => setOpen(false)}>{l.label}</a>
            </li>
          ))}
          <li>
            <a className="nav-cta" href="#contact" onClick={() => setOpen(false)}>
              Start a Conversation
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SentinelNav;
